<template>
    <div class="vod-navigation">
        <img @click="goHome" src="@/assets/img/logos/vod_logo.svg" />
        <router-link
            to="/"
            class="vod-navigation-route"
            :class="{ '-active': $route.path == '/' }"
        >
            Home
        </router-link>
        <router-link
            v-if="isSupport"
            to="/support"
            class="vod-navigation-route"
            :class="{ '-active': $route.path == '/support' }"
        >
            Klienci
        </router-link>
        <router-link
            v-if="isSupport"
            to="/support/webinars"
            class="vod-navigation-route"
            :class="{ '-active': $route.path == '/support/webinars' }"
        >
            Webinary
        </router-link>
        <router-link
            v-if="isSupport"
            to="/support/conferences"
            class="vod-navigation-route"
            :class="{ '-active': $route.path == '/support/conferences' }"
        >
            Konferencje
        </router-link>
        <router-link
            v-if="isSupport"
            to="/support/courses"
            class="vod-navigation-route"
            :class="{ '-active': $route.path == '/support/courses' }"
        >
            Kursy
        </router-link>
        <router-link
            v-if="isSupport"
            to="/support/promos"
            class="vod-navigation-route"
            :class="{ '-active': $route.path == '/support/promos' }"
        >
            Kody rabatowe
        </router-link>
        <div style="margin-left: auto;"></div>
        <div class="vod-nav-border"></div>
        <div
            v-if="!user.account_id"
            class="vod-nav-button"
            @click="toggleLogin"
        >
            {{ $t('LOG_IN_YOURSEL') }}
        </div>
        <div
            v-if="!user.account_id"
            class="vod-nav-button -border"
            @click="toggleRegister"
        >
            Zarejestruj się
        </div>
        <div v-if="user.account_id" class="vod-nav-menu">
            {{ user.display }}
            <ul class="vod-nav-menu-content">
                <li @click="goToSettings">{{ $t('MENU_SETTINGS') }}</li>
                <li @click="logout">
                    {{ $t('NAVIGATION_logoutShort') }}
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { logoutUser } from '@/helpers/utils'
export default {
    data() {
        return {
            search: '',
            searchHidden: true
        }
    },
    computed: {
        isSupport() {
            return (
                this.$store.state.user.roles &&
                this.$store.state.user.roles.some(r => r.type == 'support')
            )
        },
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        goToSettings() {
            this.$router.push('/settings')
        },
        logout() {
            logoutUser(this)
        },
        isActive(route) {
            return this.$route.matched.some(item => item.path.includes(route))
        },
        goHome() {
            this.$router.push('/')
        },
        toggleRegister() {
            this.$store.commit('setSidebarForm', 'register')
        },
        toggleLogin() {
            this.$store.commit('setSidebarForm', 'login')
        },
        hideSearch(isButton) {
            if (this.search && !isButton) {
                return
            }
            this.searchHidden = true
            this.search = ''
        },
        showSearch() {
            this.searchHidden = false
            this.$refs.input.focus()
        }
    }
}
</script>
<style lang="scss" scoped>
a {
    text-decoration: none !important;
}
.vod-navigation {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 4rem;
    display: flex;
    align-items: center;
    padding: 0.5rem 1rem;
    box-sizing: border-box;
    z-index: $medium;
    background: #141414b9;

    img {
        height: 80%;
        cursor: pointer;
        transition: $ease;

        &:hover {
            transform: $translateY;
        }
    }
}
.vod-nav-search {
    position: relative;
    display: flex;
    align-items: center;
    margin-right: 1rem;

    i {
        margin-left: auto;
        cursor: pointer;
        transition: $ease;

        &:hover {
            transform: $translateY;
        }
    }

    input {
        border: none;
        background: transparent;
        color: #fff;
        font-size: 1rem;
        text-transform: uppercase;
        padding: 0;
        padding: 0 1rem;
        padding-right: 2rem;
        transition: $ease;
        width: 100%;

        &.-hidden {
            padding: 0;
            width: 0%;
        }

        &::placeholder {
            color: #fff;
        }
    }
}
.vod-nav-border {
    width: 1px;
    height: 70%;
    background: rgba(255, 255, 255, 0.582);
}
.vod-nav-button {
    margin-left: 1rem;
    cursor: pointer;
    padding: 0.5rem 1rem;
    transition: $ease;
    position: relative;
    color: var(--color);

    &:hover {
        transform: translateY(0.1rem);
    }

    &.-border {
        border: solid 1px $accent-apple;
        border-radius: $minimal-radius;

        &:hover {
            background: $accent-apple;
            transform: none;
        }
    }
}
.clear-search {
    position: absolute;
    right: 0;
}
.vod-navigation-route {
    color: #fff;
    margin-left: 1rem;
    transition: $ease;
    font-family: $input-family;

    &.-active {
        color: $accent-yellow;
    }

    &:hover {
        transform: $translateY;
    }

    &:first-of-type {
        margin-left: 4rem;
    }
}
.vod-nav-menu {
    position: relative;
    height: calc(100% + 1rem);
    min-width: 10rem;
    margin-right: -1rem;
    padding: 0 1rem;
    cursor: pointer;
    display: flex;
    align-items: center;
}
.vod-nav-menu:hover {
    ul {
        opacity: 1;
        pointer-events: all;
    }
}
.vod-nav-menu-content {
    opacity: 0;
    pointer-events: none;
    position: absolute;
    display: flex;
    flex-direction: column;
    top: 100%;
    left: 0;
    list-style-type: none;
    z-index: $high;
    padding: 0.4rem 0;
    width: 100%;
    transition: $ease;
    margin: 0;
    margin-top: -0.4rem;

    li {
        background: #141414b9;
        padding: 1rem;
        cursor: pointer;
        transition: $ease;
        &:hover {
            background: rgba(59, 59, 59, 0.725);
        }
    }
}
@media (max-width: 1000px) {
    .vod-navigation {
        padding: 0.5rem 0.5rem;
        font-size: 0.7rem;
        img {
            height: 40%;
        }
    }
    .vod-nav-button {
        margin-left: 0.5rem;
    }
    .vod-nav-search {
        padding-left: 1rem;
        max-width: 25%;

        i {
            font-size: 1.4rem;
        }

        input {
            font-size: 0.8rem;
            padding: 0 0.5rem;
        }
    }
    .vod-navigation-route {
        &:first-of-type {
            margin-left: 1rem;
        }
    }
}
</style>
